/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-28 09:36:44
 * @LastEditTime: 2021-03-04 14:32:31
 */
import http from '@/axios/http'
// 报警通知列表
export function getAlarmNotice(data) {
  return http({
    url: '/api2/alarmNotice/list',
    method: 'post',
    data,
  })
}
// 条件搜索报警通知
export function queryAlarm(data) {
  return http({
    // url: '/api2/alarmNotice/query',
    url: '/api2/alarmNotice/list',
    method: 'post',
    data
  })
}
// 报警通知修改
export function editAlarmNotice(data) {
  return http({
    url: '/api2/alarmNotice/edit',
    method: 'post',
    data,
  })
}

// 报警通知添加
export function addAlarmNotice(data) {
  return http({
    url: '/api2/alarmNotice/add',
    method: 'post',
    data,
  })
}

// 报警通知删除
export function deleteAlarmNotice(id) {
  return http({
    url: '/api2/alarmNotice/del',
    method: 'post',
    data: {
      id,
    }
  })
}

// 报警联系人
export function getAlarmContact(data) {
  return http({
    url: '/api2/alarmContact/list',
    method: 'post',
    data,
  })
}
// 条件查询报警联系人
export function queryContact(data) {
  return http({
    // url: '/api2/alarmContact/query',
    url: '/api2/alarmContact/list',
    method: 'post',
    data,
  })
}
// 报警联系人添加
export function addAlarmContact(data) {
  return http({
    url: '/api2/alarmContact/add',
    method: 'post',
    data,
  })
}

// 报警联系人修改
export function editAlarmContact(data) {
  return http({
    url: '/api2/alarmContact/edit',
    method: 'post',
    data,
  })
}

// 报警联系人删除
export function deleteAlarmContact(id) {
  return http({
    url: '/api2/alarmContact/del',
    method: 'post',
    data: {
      id,
    }
  })
}

// 设备组态中的实时报警数据
export function realTimeAlarm(did) {
  return http({
    url: '/api2/alarmRecord/last/list',
    data: {
      did,
    },
    method: 'post'
  })
}

// 设备组态后处理报警
export function handleAlarm(data) {
  return http({
    url: '/api2/alarmRecord/edit',
    method: 'post',
    data,
  })
}

// 获取报警记录
export function getRecord(data) {
  return http({
    url: '/api2/alarmRecord/list',
    method: 'post',
    data,
  })
}
